<div class="w-full h-full">
<app-tool-loader [isLoading]="isLoading()" [positionUnset]="true">

  <p-toolbar>
    <ng-template #start>
      <div class="flex items-center gap-2 toolbar-menu">
        <p-selectButton [options]="modes" [(ngModel)]="selectedMode"
          (onChange)="onModeChange($event)" [allowEmpty]="false">
        </p-selectButton>

        @if (selectedMode === 'multiple') {
        <p-selectButton [options]="resultsDisplay"
          [(ngModel)]="selectedResultDisplay"
          (onChange)="onSelectedResultDisplayUpdated($event)" [allowEmpty]="false">
        </p-selectButton>
        }

        @if (selectedResultDisplay === 'plot') {
        <p-selectButton [options]="depthView"
          [(ngModel)]="selectedDepthView" (onChange)="depthViewToggle($event)"
          [allowEmpty]="false">
        </p-selectButton>
        }

        <app-single-load-results [loadCases]="loadCases" (loadCaseSelected)="setLoadCase($event)"
          [stateStore]="displacementResultsStore" [signalRChange]="signalRChange">
        </app-single-load-results>
      </div>
    </ng-template>
  </p-toolbar>

  @if (selectedResultDisplay === 'plot') {
  <app-single-load-plot 
    [yAxisTitle]="yAxisTitle" [xAxisTitle]="xAxisTitle" [columnDefs]="columnDefs" [data]="results"
    [selectedDepthView]="selectedDepthView"
    [loadCaseResultField]="selectedLoadCase"
    [depthUnit]="longLengthUnit"
    [plotName]="plotName" 
    [plotTitle]="'Forces/Displacements'"
    [singleLoadPlotStore]="displacementResultsStore">
  </app-single-load-plot>
  }

  <app-single-load-grid 
    [hidden]="selectedResultDisplay !== 'grid'" 
    [rowData]="results"
    [columnDefinitions]="columnDefinitions" 
    tableName="Displacements"
    gridName="Forces/Displacements">
  </app-single-load-grid>
  
  <p-dialog [draggable]="false" [visible]="errorMsg != null" [closable]="false" appendTo="self">
    <i class="pi pi-exclamation-circle pr-1"></i>
    <label>{{ errorMsg }}</label>
    <br> <br>
  </p-dialog>

  @if (displacementResults != null) {
    <app-perivis-validation [errors]="displacementResults[0]?.errors" />
  }

</app-tool-loader>
</div>